import React, { Fragment, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Label,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { H5, H3, LI, P, UL, Image, H4, H2 } from "../../../../AbstractElements";
import userImage from "../../../../assets/images/user-profile/default-users.png";
import { FaPencilAlt, FaStripeS } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router";
import SweetAlert from "sweetalert2";
import { AboutM, Active, EditProfile, Suspend } from "../../../../Constant";
import Popup from "../../../Common/Popup/Popup";
import EditProfiles from "./EditProfile";
// import { PiGear } from "react-icons/pi";
import settings from "../../../../assets/icons/PhGear 1.svg";
import { toast } from "react-toastify";
import { postDataWithToken } from "../../../../Utils/restUtils";
import {
  postActiveCustomer,
  postSuspendCustomer,
  updatePassword,
} from "../../../../CommonURL";
import { useSelector } from "react-redux";
import { selectRoleId } from "../../../../Redux/personalDetail";
const AboutMe = ({ details, fetchData }) => {
  const personalDetails = details;
  const roleId = useSelector(selectRoleId);

  const [isShow, setIsShow] = useState(true);
  const [modal, setModal] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const toggleSettings = () => setSettingsOpen(!settingsOpen);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = location.search;
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };
  const params = new URLSearchParams(searchParams);
  const param1 = params.get("id");
  const fileImport = (
    <span className="billerqColor bolder ">
      {/* <h3>{EditProfiles}</h3> */}
    </span>
  );

  const handleModal = (id) => {
    setModal(!modal);
    fetchData();

    // setcustomerId(id);
  };
  const handlePasswordSubmit = async () => {
    if (!password || !confirmPassword) {
      toast.error("Both fields are required");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    const postRequest = {
      user_id: param1,
      new_password: password,
    };

    try {
      const res = await postDataWithToken(updatePassword, postRequest);

      if (res?.data?.status === true) {
        toast.success("Password updated successfully");

        setPassword("");
        setConfirmPassword("");
        setPasswordModal(false);
      } else {
        toast.error(res?.data?.message || "Failed to update password");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const handleEdit = () => {
    // const editFormURL = `${process.env.PUBLIC_URL}/customers/customer-edit?id=${param1}`;
    // navigate(editFormURL);
    setModal(!modal);
  };
  const handlePassword = () => {
    setPasswordModal(!passwordModal);
  };

  const activeCustomer = async (data) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "You want to active customer!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then(async (result) => {
      setLoading(true);
      if (result.value) {
        const payload = { user_id: param1 };
        const packageRemove = await postDataWithToken(
          postActiveCustomer,
          payload,
        );
        if (packageRemove.data.status === true) {
          SweetAlert.fire(
            "Status Changed!",
            "Your status has been changed.",
            "success",
          );
          fetchData();
        } else {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
          setLoading(false);
        }
      } else {
        // navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }
      setLoading(false);
    });
  };
  const suspendCustomer = async (data) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "You want to suspend customer!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then(async (result) => {
      setLoading(true);
      if (result.value) {
        const payload = { user_id: param1 };
        const packageRemove = await postDataWithToken(
          postSuspendCustomer,
          payload,
        );
        if (packageRemove.data.status === true) {
          SweetAlert.fire(
            "Status Changed!",
            "Your status has been changed.",
            "success",
          );
          fetchData();
        } else {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
          setLoading(false);
        }
      } else {
        // navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
      }
      setLoading(false);
    });
  };

const AboutMeData = [
  {
    id: 1,
    icon: <i className="icofont icofont-id-card icofont-lg"></i>,
    designation: "Email",
    place: personalDetails.email || "N/A",
  },
  {
    id: 2,
    icon: <i className="icofont icofont-phone-circle icofont-lg"></i>,
    designation: "Contact No",
    place:
      "+" +
        (personalDetails.country_code || "") +
        " " +
        (personalDetails.mobile || "") || "N/A",
  },
  {
    id: 3,
    icon: <i className="icofont icofont-flag icofont-lg"></i>,
    designation: "Country",
    place: personalDetails.country || "N/A",
  },
  {
    id: 4,
    icon: <i className="icofont icofont-map icofont-lg"></i>,
    designation: "State",
    place: personalDetails.state || "N/A",
  },
  {
    id: 5,
    icon: <i className="icofont icofont-location-pin icofont-lg"></i>,
    designation: "City",
    place: personalDetails.city || "N/A",
  },
];
  return (
    <Fragment>
      <Popup isOpen={modal} title="Edit profile" toggler={handleModal}>
        <EditProfiles props={personalDetails} handleModal={handleModal} />
      </Popup>
      <Popup
        isOpen={passwordModal}
        title="Change Password"
        toggler={() => setPasswordModal(false)}
      >
        <Col md="12" className="mb-3">
          <Label className="form-label">New Password</Label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Col>
        <Col md="12" className="mb-3">
          <Label className="form-label">Confirm Password</Label>
          <input
            type="password"
            className="form-control"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </Col>

        <div className="d-flex justify-content-end gap-2">
          <button
            className="btn btn-secondary"
            onClick={() => setPasswordModal(false)}
          >
            Cancel
          </button>

          <button className="btn btn-primary" onClick={handlePasswordSubmit}>
            Update Password
          </button>
        </div>
      </Popup>

      <Card data-intro="This is your Your detail" className="step4">
        <CardHeader>
          <H3
            attrH3={{
              className:
                "p-0 d-flex align-items-center justify-content-between",
            }}
          >
            {AboutM}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* <FaPencilAlt title="Customer Edit " onClick={() => handleEdit()} style={{ cursor: 'pointer', marginLeft: 'auto', fontSize: '0.8em',}} /> */}
             {roleId == 1&& ( <Dropdown isOpen={settingsOpen} toggle={toggleSettings}>
                <DropdownToggle tag="span" style={{ cursor: "pointer" }}>
                  <img src={settings} alt="settings" />
                </DropdownToggle>

                <DropdownMenu end>
                  <DropdownItem style={toggleStyle} onClick={handlePassword}>
                    Change Password
                  </DropdownItem>

                  <DropdownItem style={toggleStyle} onClick={handleEdit}>
                    Edit
                  </DropdownItem>
                  {personalDetails.status === "suspended" && (
                    <DropdownItem
                      style={toggleStyle}
                      onClick={() => activeCustomer()}
                    >
                      {Active}
                    </DropdownItem>
                  )}
                  {personalDetails.status === "active" && (
                    <DropdownItem
                      style={toggleStyle}
                      onClick={() => suspendCustomer()}
                    >
                      {Suspend}
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
             )}
            </div>
          </H3>
        </CardHeader>
        <div className={`collapse ${isShow ? "show" : ""}`}>
          <CardBody className="post-about">
            <UL attrUL={{ className: "simple-list" }}>
              <div className="d-flex" style={{ marginBottom: "30px" }}>
                <Image
                  attrImage={{
                    className:
                      "img-60 img-fluid m-r-20 rounded-circle img-thumbnail",
                    alt: "user",
                    src: userImage,
                  }}
                />
                <div className="media-body flex-grow-1">
                  <H5 className="d-block">
                    {personalDetails.first_name} {personalDetails.last_name}
                  </H5>
                </div>
              </div>
              <div className="row">
                {" "}
                {/* Add row class here */}
                {AboutMeData.map((item) => (
                  <div
                    key={item.id}
                    className="col-sm-6 col-md-4 col-xl-12"
                    style={{ marginBottom: "10px", marginTop: "10px" }}
                  >
                    {" "}
                    {/* Wrap each LI in a col-md-4 */}
                    <LI>
                      <div className="icon">{item.icon}</div>
                      <div>
                        <H5>{item.designation}</H5>
                        <span attrPara={{ className: "text-dark" }}>
                          {item.place}
                        </span>
                      </div>
                    </LI>
                  </div>
                ))}
              </div>
            </UL>
          </CardBody>
        </div>
      </Card>
    </Fragment>
  );
};

export default AboutMe;
